import React from "react";
import { Button } from "../../../../Components/ui/button";

interface RejectCampaignDialogProps {
  open: boolean;
  comment: string;
  setComment: React.Dispatch<React.SetStateAction<string>>;
  onClose: () => void;
  onConfirm: (comment: string) => void;
}

const RejectCampaignDialog: React.FC<RejectCampaignDialogProps> = ({
  open,
  comment,
  setComment,
  onClose,
  onConfirm,
}) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black/30">
      <div className="bg-white rounded-xl p-6 w-full max-w-md border">
        <h2 className="text-lg font-semibold mb-4">
          Are you sure do you want to Reject the Campaign?
        </h2>
        <textarea
          className="w-full h-24 p-3 border rounded-lg mb-5 text-base text-gray-500 outline-none"
          placeholder="Add Your comment here"
          value={comment}
          onChange={e => setComment(e.target.value)}
        />
        <div className="flex gap-4 justify-end">
          <Button
            variant="outline"
            className="border-red-500 text-red-500 hover:bg-red-500 hover:text-white"
            onClick={onClose}
            type="button"
          >
            No
          </Button>
          <Button
            className="bg-[#2563eb] text-white"
            onClick={() => {
              onConfirm(comment);
              // Don't reset comment here—let parent handle it after closing
            }}
            type="button"
          >
            Yes
          </Button>
        </div>
      </div>
    </div>
  );
};

export default RejectCampaignDialog;
